import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import type {
  ConfirmAgreementsMutation,
  ConfirmAgreementsMutationVariables
} from './__generated__/ConfirmAgreementsMutation'

const mutation: TypedDocumentNode<
  ConfirmAgreementsMutation,
  ConfirmAgreementsMutationVariables
> = gql`
  mutation ConfirmAgreementsMutation($input: ConfirmAgreementsInput!) {
    confirmAgreements(input: $input) {
      status
    }
  }
`

export function confirmAgreementsMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      ConfirmAgreementsMutation,
      ConfirmAgreementsMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
